// Generated by purs version 0.14.3
"use strict";
var $foreign = require("./foreign.js");
var Data_ByteString = require("../Data.ByteString/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Node_Encoding = require("../Node.Encoding/index.js");
var Keccak256 = function (keccak256) {
    this.keccak256 = keccak256;
};
var keccak256ByteString = new Keccak256($foreign["_keccak256"]);
var keccak256 = function (dict) {
    return dict.keccak256;
};
var keccak256HexString = new Keccak256((function () {
    var $1 = keccak256(keccak256ByteString);
    return function ($2) {
        return $1(Network_Ethereum_Core_HexString.toByteString($2));
    };
})());
var keccak256String = new Keccak256((function () {
    var $3 = keccak256(keccak256ByteString);
    var $4 = Data_Maybe.fromJust();
    var $5 = Data_Function.flip(Data_ByteString.fromString)(Node_Encoding.UTF8.value);
    return function ($6) {
        return $3($4($5($6)));
    };
})());
var toSelector = (function () {
    var $7 = Network_Ethereum_Core_HexString.takeHex(8);
    var $8 = keccak256(keccak256String);
    return function ($9) {
        return $7(Network_Ethereum_Core_HexString.fromByteString($8($9)));
    };
})();
module.exports = {
    Keccak256: Keccak256,
    keccak256: keccak256,
    toSelector: toSelector,
    keccak256ByteString: keccak256ByteString,
    keccak256String: keccak256String,
    keccak256HexString: keccak256HexString
};
